import React, {forwardRef, useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(),
        padding: theme.spacing(0, 1),
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 300
        },
        '&.fullWidth': {
            [theme.breakpoints.up('sm')]: {
                width: '100%'
            }
        },
        '&.noMarginBottom': {
            marginBottom: 0
        }
    },
    input: {
        marginLeft: 8,
        flex: 1
    },
    iconButton: {
        padding: 10
    },
    divider: {
        width: 1,
        height: 28,
        margin: '0 4px'
    }
}));

export const ENTER_KEY = 'Enter';

const GenericSearchField = forwardRef((props, ref) => {
    const {
        fullWidth = false,
        marginBottom = true,
        placeholder = 'Pesquisar...',
        onSearch = () => {},
        disabled = false
    } = props;
    const classes = useStyles();
    const [inputValue, setInputValue] = useState('');

    function onChange(event) {
        setInputValue(event.target.value);
    }

    function onKeyUp(event) {
        if (event.key === ENTER_KEY) {
            onSearch(inputValue);
        }
    }

    function onClick(event) {
        onSearch(inputValue);
    }

    return (
        <Paper className={clsx(classes.root, fullWidth && 'fullWidth', !marginBottom && 'noMarginBottom')}>
            <InputBase
                inputRef={ref}
                className={classes.input}
                placeholder={placeholder}
                value={inputValue}
                onChange={onChange}
                onKeyUp={onKeyUp}
                inputProps={{ 'aria-label': 'Buscar' }}
                disabled={disabled} />
            <IconButton
                className={classes.iconButton}
                aria-label='search'
                onClick={onClick}>
                <SearchIcon />
            </IconButton>
        </Paper>
    );
});

GenericSearchField.propTypes = {
    fullWidth: PropTypes.bool,
    placeholder: PropTypes.string
};

export default GenericSearchField;